import { useContext, useEffect } from 'react';
import { MakeToast } from '../../../components';
import { LoginContext } from '../../../utils/context';
import API from '../../../services/api-middleware';
import { SessionExpired, SessionTimeout } from '../../data/constants';
import './session-expire-modal.css';

const baseUrl = process.env.REACT_APP_USER_SERVER_URL;
const llmBaseUrl = process.env.REACT_APP_LLM_SERVER_URL;

const logout = async () => {
  let token = localStorage.getItem('token');
  if (token !== null) {
    token = JSON.parse(token);
  }
  await API(baseUrl)
    .post(
      '/logout',
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
    .then(() => localStorage.clear())
    .catch((err) => MakeToast('error', err?.response?.data?.message || 'Logout failed'));
};

const clearDB = async () => {
  let token = localStorage.getItem('token');
  if (token !== null) {
    token = JSON.parse(token);
  }
  let userId = localStorage.getItem('user_id');
  if (userId !== null) {
    userId = JSON.parse(userId);
  }
  await API(llmBaseUrl)
    .post(
      'clear_data',
      { user_id: userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then(() => localStorage.clear())
    .catch((err) => MakeToast('error', err?.response?.data?.message || 'Failed to clear data'));
};

function Logout() {
  const { setIsLoggedIn } = useContext(LoginContext);

  useEffect(() => {
    const session = localStorage.getItem('sessionExpired');
    if (session) {
      logout?.();
      clearDB?.();
    }
    setTimeout(() => setIsLoggedIn(false), 2000);
    localStorage.setItem('sessionExpired', 'true');
  }, []);

  return (
    <div className="modal-container bg-[rgba(0,0,0,0.46)] flex items-center justify-center fixed h-full w-full z-[1000] left-0 top-0">
      <div className="custom-modal bg-[white] relative min-w-[400px] pt-[60px] pb-[30px] px-[30px] rounded-lg">
        <h2 className="modal__heading text-2xl leading-[31.2px] font-[600px] text-center">
          {SessionTimeout}
        </h2>
        <p className="modal__subheading text-base leading-6 text-center whitespace-pre-line">
          {SessionExpired}
        </p>
      </div>
    </div>
  );
}

export default Logout;
